import { defineStore } from 'pinia'
import { computed, ref, readonly } from 'vue'

export const useMissionStore = defineStore('missionStore', () => {
  // state
  const missions = ref<any>([])
  const cachedFilter = ref<any>({})
  const missionCount = ref<any>({
    normalFullCounts: 0,
    landFullCounts: 0,
    allFullCounts: 0,
    normalCounts: 0,
    landCounts: 0,
    allCounts: 0,
    allNormalCounts: 0,
    allLandCounts: 0,
  })
  const firstPageData = ref<any>([])
  const missionInfo = ref<any>({})

  // getters
  const getMissions = computed(() => [...missions.value])
  const getMissionCounts = computed(() => readonly(missionCount.value))
  const getFirstPageData = computed(() => [...firstPageData.value])
  const getFrontierMission = computed(() => readonly(missionInfo.value))

  const getFilteredMissions = computed(() => (data: any) =>
    missions.value.filter(m => {
      return (
        (!data.cooperationType || data.cooperationType == 2 || m.cooperationType === data.cooperationType) &&
        (!data.targetType || !data.targetType.length || data.targetType.includes(m.missionTargetType)) &&
        (!data.lvs || !data.lvs.length || data.lvs.includes(m.lv))
      )
    })
  )

  // actions
  async function fetchMissionCounts(data) {
    let count = { ...missionCount.value }
    let missionList = cachedFilter.value[JSON.stringify(data)]
    if (!missionList || !missionList.length) {
      const res = await this.$nuxt.$questsService.getPublicMissionInfos(
        data.cooperationType,
        data.isFull,
        data.offset || 0,
        data.limit || 10000,
        data.targetType,
        data.lvs
      )
      missionList = res.missionInfosList
    }

    if (data.isFull) {
      count.normalFullCounts = 0
      count.landFullCounts = 0
      count.allFullCounts = 0
    } else {
      count.normalCounts = 0
      count.landCounts = 0
      count.allCounts = 0
    }

    missionList.forEach(mission => {
      if (mission.cooperationType == 0) {
        if (!data.isFull) count.normalCounts++
        else count.normalFullCounts++
        if (!data.isFull) count.allCounts++
        else count.allFullCounts++
      } else if (mission.cooperationType == 1) {
        if (!data.isFull) count.landCounts++
        else count.landFullCounts++
        if (!data.isFull) count.allCounts++
        else count.allFullCounts++
      }
    })

    // 全体の場合は右上のポッチ表示数
    if (!data.isFull && data.cooperationType == 2 && !data.targetType.length && !data.lvs.length) {
      count.allNormalCounts = count.normalCounts
      count.allLandCounts = count.landCounts
    }

    missions.value = missionList
    cachedFilter.value[JSON.stringify(data)] = missionList
    missionCount.value = count
  }

  async function fetchMyMissionCount(cooperationType) {
    let count = { ...missionCount.value }
    const myMissionList = await this.$nuxt.$questsService.getMyMissionInfos(cooperationType, 0, 10000)
    let data = [...myMissionList.missionInfosList]
    if (data.length) data = data.slice(0, 20)
    firstPageData.value = data
    if (cooperationType == 0) {
      count.myNormalMissionCounts = myMissionList.missionInfosList.length
    } else if (cooperationType == 1) {
      count.myLandMissionCounts = myMissionList.missionInfosList.length
    } else if (cooperationType == 2) {
      count.myAllMissionCounts = myMissionList.missionInfosList.length
    }
    missionCount.value = count
  }

  function resetMissions() {
    cachedFilter.value = {}
    missions.value = []
  }

  function setFrontierMission(data) {
    missionInfo.value = Object.assign({}, missionInfo.value, data)
  }

  return {
    missions,
    cachedFilter,
    missionCount,
    firstPageData,
    missionInfo,
    getMissions,
    getMissionCounts,
    getFirstPageData,
    getFilteredMissions,
    getFrontierMission,
    fetchMissionCounts,
    fetchMyMissionCount,
    resetMissions,
    setFrontierMission,
  }
})
